import moment from "moment";

export const formatDate = (dateString, isSecondaryDeal = false) => {
  const dateFormatPrimary = "MMM DD, YYYY";
  const dateFormatSecondary = "lll";
  return dateString ? moment(dateString).format(isSecondaryDeal ? dateFormatSecondary : dateFormatPrimary) : "-";
};